import logger from "@/utils/logger";
import { stringify } from "querystring";
import { history } from "umi";

export function redirectUserToLoginPage(redirect = "") {
	logger("Redirecting user to login page.", 0);
	if (window.location.pathname !== "/user/login" && !redirect) {
		history.go({
			pathname: "/user/login",
			search: stringify({
				redirect: window.location.href,
			}),
		});
	}
}
